module.exports = __webpack_public_path__ + "static/media/WMCEF_Donor Langauge.ec617c72.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/WMCEF_Donor Langauge.pdf
// module id = 119
// module chunks = 0